import styled from 'styled-components';

import { FrayedDividerProps } from './types';

export const Wrapper = styled.img<FrayedDividerProps>`
	transform: rotate(${p => (p.isFlipped ? '180deg' : '0deg')});
	vertical-align: bottom;
	width: 100%;
`;
